import styled from 'styled-components';
import { px2rem, mq } from '../../../../stylesheets/tools';

const StyledEducationStep = styled.div`
  .step-headline {
    display: flex;
    margin-bottom: ${px2rem('30px')};
    gap: ${px2rem('15px')};

    .step-headline__text {
      max-width: ${px2rem('1040px')};
    }

    ${mq('m')} {
      gap: 0;
      align-items: center;
      margin-bottom: 0;
    }

    ${mq('m')} {
      .step-headline__number {
        width: ${px2rem('100px')};
        flex-shrink: 0;
      }
    }
  }

  .step-content {
    max-width: ${px2rem('1040px')};

    .step-content__image {
      width: 100%;
      margin-bottom: ${px2rem('20px')};
    }

    ${mq('m')} {
      margin-left: ${px2rem('100px')};

      .step-content__image {
        margin: ${px2rem('30px')} 0;
      }
    }

    [type='embeddedVideo'] {
      margin: 0;
    }
  }
`;

export default StyledEducationStep;
